export default __webpack_public_path__ + "0808110559dcc1045908f65fd44d5fb2.png";